module.exports = __webpack_public_path__ + "assets/img/six.32776e84.png";